import { message } from "antd";
import axiosInstance from "../shared/axios";

// get all users
const getAllUsers = async (params) => {
  try {
    const result = await axiosInstance.get("/user/viewAll", {
      params: {
        name: params?.name || "",
        role_id: params?.role_id,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading users");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading users",
    );
    return { data: [], total: 0 };
  }
};

const addEditUser = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/user/update" : "/user/store",
      { ...payload, id: id || null },
    );
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save user",
    };
  }
};

const deleteUser = async (id) => {
  try {
    const result = await axiosInstance.delete(`/user/delete/${id}`);

    if (result?.data?.success === true) {
      return { success: true };
    } else {
      return {
        success: false,
        message: result?.data?.message,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to user role",
    };
  }
};

export const userapi = {
  getAllUsers,
  addEditUser,
  deleteUser,
};
